import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { changeFullScreenTipVisibilityAction, toggleFullScreenAction } from '../actions/mvk_state';
import { MainBlock } from '../components/main_block';
function mapStateToProps(state) {
  return {
    isFullScreen: state.MVKState.isFullScreen,
    isPanoramaActive: state.MVKState.map.isPanoramaActive,
    isOfferCard: state.MVKState.isOfferCard
  };
}
function mapDispatchToProps(dispatch) {
  return {
    changeFullScreenTipVisibility: bindActionCreators(changeFullScreenTipVisibilityAction, dispatch),
    toggleFullScreen: bindActionCreators(toggleFullScreenAction, dispatch)
  };
}
export var MainBlockContainer = connect(mapStateToProps, mapDispatchToProps)(MainBlock);